/**
 * 連珠 (Renju, 15x15) の TypeScript 表現 (mixed-engine の serde 形と一致)。
 */

export type Side = 'First' | 'Second';

export type RenjuOutcomeReason = 'Five' | 'Overline' | 'Forbidden';

export interface RenjuOutcome {
  winner: Side | null;
  reason: RenjuOutcomeReason;
}

export interface RenjuState {
  board: (Side | null)[][];
  side: Side;
  plies: number;
  swap_count: number;
  last_was_swap: boolean;
  outcome: RenjuOutcome | null;
}

export type RenjuMove = 'Swap' | { Place: { row: number; col: number } };

export const RENJU_SIZE = 15;

export function isPlace(m: RenjuMove): m is { Place: { row: number; col: number } } {
  return typeof m === 'object' && 'Place' in m;
}

export function legalKey(row: number, col: number): string {
  return `${row}-${col}`;
}

/** Swap が legal 集合に含まれるか。 */
export function hasSwap(legal: RenjuMove[] | undefined): boolean {
  return (legal ?? []).some((m) => m === 'Swap');
}

/** State.side is the fixed player slot; stones change hands after each exchange. */
export function renjuColorForSlot(state: Pick<RenjuState, 'swap_count'>, slot: Side): Side {
  return state.swap_count % 2 === 1 ? (slot === 'First' ? 'Second' : 'First') : slot;
}
/** Do not expose a stale legal-list exchange during a snapshot transition. */
export function renjuSwapStage(state: Pick<RenjuState, 'plies' | 'swap_count' | 'last_was_swap' | 'outcome'>): boolean {
  return state.outcome == null && state.plies >= 1 && state.plies <= 5 && state.swap_count < 5 && !state.last_was_swap;
}
